// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__jlTs+","logo":"style_logo__AH69g"};